import { StringifyPlainObject } from '../plainObjects/stringify.plainObject';
import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { SchemaUtil } from '../utils/schema.util';
import { ExpressionColumnPlainObject } from '../plainObjects/expressionColumn.plainObject';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class StringifyVisitor extends BaseTransformationVisitor {
    private get _StringifyTransformation(): StringifyPlainObject {
        return this.transformation as StringifyPlainObject;
    }

    public visitAssignment(assignment: any): ExpressionColumnPlainObject {
        const stringifyColumn = new ExpressionColumnPlainObject();
        stringifyColumn.name = SchemaUtil.getColumnName(assignment.columnIdentifier());
        if (assignment.expression()) {
            stringifyColumn.expression = this._getText(assignment.expression().left);
            stringifyColumn.typeExpression = this._getText(assignment.expression().right);
        }
        this._StringifyTransformation.columns.push(stringifyColumn);
        return stringifyColumn;
    }
}
